import Modal from "./General/Modal";
import Input from "./General/Input";
import { useFormik } from "formik"
import Button from "./General/Button";
import { MixpanelTracking } from "../MixPanel";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { setSnackBar } from "../store/ToastSlice";

function WhatsAppModal({show, onClose} : any) {
    const initialValues = {
        phone: ''
    }
    const dispatch : any = useDispatch();
    const { values, errors, handleSubmit, handleBlur, handleChange, touched } = useFormik({
        initialValues: initialValues,

        validationSchema : Yup.object({
            phone : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid phone number!')
        }),

        onSubmit: (values, action) => {
            MixpanelTracking.getInstance().toWhatsAppChat({
                phone : values.phone
            });
            onClose();
            action.resetForm();
            dispatch(setSnackBar(
                {
                    color : 'success',
                    message : 'Thank you for providing the details!'
                }
            ));
            window.open('https://api.whatsapp.com/send?phone=918655735634', '_blank');
        }
    });

    return (
        <Modal transition="animateup" show = {show} styles='w-[80%] lg:w-[35%] rounded-[5px] bg-transparent'>
            <div>
                <div onClick={onClose} className="flex justify-end bg-white w-7 h-7 flex items-center justify-center ml-auto rounded-[50%] mb-[10px] cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 rounded-[50%] text-theme-black">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div className="w-full px-[25px] py-[25px] bg-white rounded-[8px]">
                    <form onSubmit={handleSubmit} >
                        <Input 
                            label = "Enter Your Number"
                            labelColor = "#444444"
                            labelProperties = "lg:mb-[10px] text-[14px] lg:text-[16px]"
                            outerProperties = "rounded border-[rgba(0, 0, 0, 0.10)] bg-[#F5F5F5]"
                            properties='rounded h-[44px] placeholder:text-[15px]'
                            name='phone'
                            value={values.phone}
                            onBlur={handleBlur}
                            error={errors.phone}
                            touched={touched.phone}
                            onChange={handleChange}
                            background = "#F5F5F5"
                            placeholder = {'eg. +91 83723 xxxxxx'}
                        />


                        <Button type = "submit" destinationEvent = "External Redirection to WhatsApp | From WhatsApp Modal" styles = "flex bg-theme-orange rounded-[5px] w-full h-[52px] mt-[22px] text-[#393F46]">
                            <img className="w-[24px] mr-[10px]" src="/WhatsAppIcon.svg" alt="WA" />
                            <p className="text-[18px] font-[500] text-white"> Continue On WhatsApp </p>
                        </Button>
                    </form>
                </div>
                
            </div>
        </Modal>
    )
}

export default WhatsAppModal